module.exports = __webpack_public_path__ + "static/img/img-install-tag-bus-top.e1f24f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-bus-top.svg
// module id = 1785
// module chunks = 1